<template>
  <div
    style="padding:10px 5px;height:calc(100% - 20px)"
    class="uk-position-relative"
  >
    <v-search
      v-bind="searchAttrs"
      @searchFn="search"
      @deleteFn="mulDel"
      @batchHandleFn="batchHandle"
      @resetFn="resetFn"
    />
    <!--<ArrowButton class="btn-alarm-trigger" @click="toAlarmTrigger">-->
    <!--  {{ $t('integration.alarm_triggering') }}-->
    <!--</ArrowButton>-->
    <SuperTable
      v-bind="tableAttrs"
      ref="stable"
      style="height:calc(100% - 150px)"
      :req="getAlarmRecordPage"
      :params="[searchAttrs.SearchForm]"
    >
      <template #operation="{ row }">
        <i class="el-icon-tickets cursor-pointer " @click="detail(row)"></i>
        <i
          class="el-icon-delete cursor-pointer uk-margin-small-left"
          @click="del(row)"
        ></i>
      </template>
    </SuperTable>
    <DyForm
      :formAttrs="{ width: '700px' }"
      :mode="'view'"
      :buttons="['cancel']"
      v-bind="dialogAttrs"
    ></DyForm>
    <BatchHandleDialog v-if="isShowBatchHandleDialog" :isShow="isShowBatchHandleDialog"
      :exIds="batchExIds"
      :detail="batchDetail"
      @close="isShowBatchHandleDialog = false"
    />
  </div>
</template>

<script>
import {
  fAlarmCause,
  fAlarmContent,
  // fAlarmLayer,
  fAlarmObject,
  fAlarmTime,
  fAlarmWay,
  fCarrier,
  fCustomer,
  fScene
} from '@/config/form/formItem/form'
import {
  colAlarmObject,
  colAlarmReason,
  colAlarmRecordCarrier,
  colCreateTime,
  colCustomer,
  colLayer
} from '@/config/table/columns/columns'
import { formContent, operationBtn, searchForm } from './search'
import DyForm from '@/components/DyForm/DyForm.vue'
import SuperTable from '@/components/SuperTable/SuperTable.vue'
import {
  delAlarmRecord,
  getAlarmRecordDetail,
  getAlarmRecordPage
} from '@/api/modules/alarmRecord'
import mixinRange from '@/utils/getRange.js'
import { getIsSys } from '@/utils/permission'
import ArrowButton from '@/components/ArrowButton/ArrowButton'
import { alarmTrigger } from '@/utils/winDetail'
import BatchHandleDialog from '@/pages/abnormal/invalidRule/BatchHandleDialog.vue'

export default {
  mixins: [mixinRange],
  data () {
    return {
      getAlarmRecordPage,
      // 详情对话框标题与值
      detailTitle: '',
      detailValue: null,
      // 批量处理
      isShowBatchHandleDialog: false,
      batchExIds: [],
      batchDetail: [],
      // 条件搜索属性整合
      searchAttrs: {
        formContent: [...formContent],
        SearchForm: { ...searchForm },
        inline: true,
        optareBtn: operationBtn
      }
    }
  },
  computed: {
    // 表格列（响应式 i18n，切换语言时实时更新）
    columns () {
      return Object.freeze([
        { ...colCustomer, title: this.$t('integration.customer') },
        { ...colAlarmRecordCarrier, title: this.$t('integration.monitoring_point') },
        { ...colAlarmReason, title: this.$t('integration.alarm_reason') },
        { ...colAlarmObject, title: this.$t('integration.alarm_object') },
        { ...colCreateTime, title: this.$t('integration.alarm_time') }
      ])
    },
    // 表格属性整合
    tableAttrs () {
      return {
        //  禁止对组件添加响应式 vue2没有markraw
        columns: this.columns,
        selection: true,
        params: [searchForm]
      }
    },
    // 详情对话框表单项（响应式 i18n；引用 detailValue 以在 detail() 调用时重新生成数组，触发 DyForm 的 watch form 显示浮动框）
    dialogForm () {
      this.detailValue
      return Object.freeze([
        { ...fCustomer, title: this.$t('integration.customer') },
        { ...fScene, title: this.$t('integration.organizational_unit') },
        { ...fCarrier, title: this.$t('integration.monitoring_point') },
        { ...fAlarmCause, title: this.$t('integration.alarm_reason') },
        { ...fAlarmObject, title: this.$t('integration.alarm_object') },
        { ...fAlarmWay, title: this.$t('integration.alarm_mode') },
        { ...fAlarmTime, title: this.$t('integration.alarm_time') },
        { ...fAlarmContent, title: this.$t('integration.alarm_content') }
      ])
    },
    // 对话框属性整合
    dialogAttrs () {
      return {
        form: this.dialogForm,
        title: this.detailTitle,
        value: this.detailValue
      }
    }
  },
  components: {
    DyForm,
    SuperTable,
    ArrowButton,
    BatchHandleDialog
  },
  methods: {
    getList () {
      this.$refs.stable.getList()
    },
    async detail (row) {
      const value = (await getAlarmRecordDetail({ id: row.id })).result
      this.detailTitle = `${row[colAlarmRecordCarrier.index]} - [${this.$timetransition(
        row[colCreateTime.index]
      )}]`
      this.detailValue = value
    },
    search (params) {
      if (params.time && params.time.length > 0) {
        // 将时间定义为不可被枚举 从而阻止其提交至后台
        if (this.searchAttrs.SearchForm.propertyIsEnumerable('time')) {
          Object.defineProperty(this.searchAttrs.SearchForm, 'time', {
            value: this.searchAttrs.SearchForm.time,
            enumerable: false,
            configurable: true,
            writable: true
          })
        }

        this.searchAttrs.SearchForm.form = new Date(params.time[0]).getTime()
        this.searchAttrs.SearchForm.to = new Date(params.time[1]).getTime()
      }

      this.$refs.stable.getList()
    },
    getRangeFn () {
      this.getRange('scope', 1).then(({ result }) => {
        if (result.length) {
          if (result[0].code === 'global_all') {
            result[0].id = undefined
          }
        }
        this.rangeArray = result
        if (this.$store.state.type === 2 || this.$store.state.type === 3) {
          this.searchAttrs.formContent[2].selectParam = result.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
          // this.formContent[1].selectParam.unshift({ value: null, label: 'public.please' });
        }
      })
    },
    // 批量删除
    async mulDel () {
      const selection = this.$refs.stable.getSelection()
      if (!selection.length) {
        this.$message.warning($t('integration.please_select_at_least_one_data'))
        return
      }

      await this.$confirm(
        this.$t(
          $t('integration.are_you_sure_you_want_to_perform_this_operation_q')
        )
      )
      await delAlarmRecord(selection.map(item => item.id))
      this.$refs.stable.getList()
    },
    // 批量处理
    batchHandle () {
      const selection = this.$refs.stable.getSelection()
      if (!selection.length) {
        this.$message.warning($t('integration.please_select_at_least_one_data'))
        return
      }
      this.batchExIds = selection.map(item => item.exId)
      this.batchDetail = selection
      this.isShowBatchHandleDialog = true
    },
    // 单条删除
    async del (row) {
      await this.$confirm(
        $t($t('integration.are_you_sure_you_want_to_perform_this_operation_q'))
      )
      await delAlarmRecord([row.id])
      this.$refs.stable.getList()
    },
    resetFn () {
      this.searchAttrs.SearchForm = { ...searchForm }
      this.getList()
    },
    toAlarmTrigger () {
      alarmTrigger()
    }
  },
  mounted () {
    this.$refs.stable.getList()
    // 非平台用户去掉客户
    if (!getIsSys()) {
      this.searchAttrs.formContent.splice(2, 1)
    } else {
      this.getRangeFn()
    }
  }
}
</script>

<style scoped lang="scss">
.btn-alarm-trigger {
  // width: 90px;
  position: absolute;
  right: 15px;
  top: 20px;
}
</style>
